// src/app/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../App.css";
import "./styles/base.css";
import { ScrollToTop } from "./ScrollToTop";
import { Navigate } from "react-router-dom";
import { AuthProvider } from "../features/auth/application/AuthContext";
import { Navbar } from "../features/landing/presentation/components/Navbar";
import { LandingPage } from "../features/landing/presentation/pages/LandingPage";
import { AboutPage } from "../features/landing/presentation/pages/AboutPage";
import { ServicePage } from "../features/landing/presentation/pages/ServicePage";
import { PremiumPage } from "../features/landing/presentation/pages/PremiumPage";
import { ContactPage } from "../features/landing/presentation/pages/ContactPage";
import { JobListPage } from "../features/landing/presentation/pages/JobListPage";
import { JobDetailPage } from "../features/landing/presentation/pages/JobDetailPage";
import { JobSeekerApplyPage } from "../features/landing/presentation/pages/JobSeekerApplyPage";
import { CompanyRegisterPage } from "../features/landing/presentation/pages/CompanyRegisterPage";
import { CompanyRepApplyPage } from "../features/landing/presentation/pages/CompanyRepApplyPage";
import { CompanyManagerApplyPage } from "../features/landing/presentation/pages/CompanyManagerApplyPage";
import { PlannerRecruitApplyPage } from "../features/landing/presentation/pages/PlannerRecruitApplyPage";
import { AgentJobBoardPage } from "../features/landing/presentation/pages/AgentJobBoardPage";
import { AgentJobBoardDetailPage } from "../features/landing/presentation/pages/AgentJobBoardDetailPage";
import { RegisterPage } from "../features/auth/presentation/pages/RegisterPage";
import { LoginPage } from "../features/auth/presentation/pages/LoginPage";
import { VerifyEmailPage } from "../features/auth/presentation/pages/VerifyEmailPage";
import { ForgotPasswordPage } from "../features/auth/presentation/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "../features/auth/presentation/pages/ResetPasswordPage";
import { CompanyProfilePage } from "../features/auth/presentation/pages/CompanyProfilePage";
import { AccountPage } from "../features/auth/presentation/pages/AccountPage";
import { ReceivedApplicationDetailPage } from "../features/auth/presentation/pages/ReceivedApplicationDetailPage";
import { CareersPage } from "../features/landing/presentation/pages/CareersPage";
import { CareerDetailPage } from "../features/landing/presentation/pages/CareerDetailPage";
import { useAuthContext } from "../features/auth/application/AuthContext";
import { useLocation } from "react-router-dom";

function RootRedirect() {
    const isMobile = window.innerWidth < 768;
    return <Navigate to={isMobile ? "/premium" : "/landing"} replace />;
}

function AuthRoute({ children }) {
    const { isLoggedIn } = useAuthContext();
    const location = useLocation();
    if (!isLoggedIn) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    return children;
}

function CompanyRoute({ children }) {
    const { isLoggedIn, member } = useAuthContext();
    const location = useLocation();
    if (!isLoggedIn) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    if (member?.role !== 'COMPANY') return <Navigate to="/" replace />;
    return children;
}

function CompanyApprovedRoute({ children }) {
    const { isLoggedIn, member } = useAuthContext();
    const location = useLocation();
    if (!isLoggedIn) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    if (member?.role !== 'COMPANY') return <Navigate to="/" replace />;
    if (member?.companyStatus !== 'APPROVED') return <Navigate to="/company/profile" replace />;
    return children;
}


export function App() {
    return (
        <Router>
            <AuthProvider>
                <ScrollToTop />
                <Navbar visible={true} />
                <div className="App" style={{ paddingTop: 80 }}>
                    <Routes>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path="/landing" element={<LandingPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/service" element={<ServicePage />} />
                        <Route path="/premium" element={<PremiumPage />} />
                        <Route path="/premium/apply" element={<JobSeekerApplyPage />} />
                        <Route path="/premium/apply/planner" element={<JobSeekerApplyPage planner />} />
                        <Route path="/premium/company" element={<CompanyApprovedRoute><CompanyRegisterPage /></CompanyApprovedRoute>} />
                        <Route path="/premium/company/rep" element={<CompanyApprovedRoute><CompanyRepApplyPage /></CompanyApprovedRoute>} />
                        <Route path="/premium/company/manager" element={<CompanyApprovedRoute><CompanyManagerApplyPage /></CompanyApprovedRoute>} />
                        {/* 대표/담당자 선택 화면(PlannerRoleBridgePage)은 2026-09-13 제거 — 채용등록은 바로 등록 폼(AGENCY_CEO)으로 진입 */}
                        <Route path="/premium/company/planner" element={<Navigate to="/premium/company/planner/rep" replace />} />
                        <Route path="/premium/company/planner/rep" element={<CompanyApprovedRoute><PlannerRecruitApplyPage applicantType="AGENCY_CEO" /></CompanyApprovedRoute>} />
                        <Route path="/premium/company/planner/manager" element={<CompanyApprovedRoute><PlannerRecruitApplyPage applicantType="HR_MANAGER" /></CompanyApprovedRoute>} />
                        <Route path="/premium/job-board" element={<AgentJobBoardPage />} />
                        <Route path="/premium/job-board/:type/:id" element={<AgentJobBoardDetailPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/jobs" element={<JobListPage />} />
                        <Route path="/jobs/:id" element={<JobDetailPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/verify-email" element={<VerifyEmailPage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                        <Route path="/account" element={<AuthRoute><AccountPage /></AuthRoute>} />
                        <Route path="/account/received/:applicationId" element={<AuthRoute><ReceivedApplicationDetailPage /></AuthRoute>} />
                        <Route path="/company/profile" element={<CompanyRoute><CompanyProfilePage /></CompanyRoute>} />
                        <Route path="/careers" element={<CareersPage />} />
                        <Route path="/careers/:id" element={<CareerDetailPage />} />
                    </Routes>
                </div>
            </AuthProvider>
        </Router>
    );
}

export default App;
